var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80026 0.233912C3.87886 0.155418 3.98539 0.111328 4.09647 0.111328C4.20754 0.111328 4.31408 0.155418 4.39267 0.233912L7.74593 3.58717C7.78711 3.62554 7.82014 3.67182 7.84305 3.72323C7.86596 3.77465 7.87828 3.83015 7.87927 3.88643C7.88026 3.94272 7.86991 3.99862 7.84883 4.05081C7.82775 4.103 7.79637 4.15041 7.75657 4.19022C7.71677 4.23002 7.66935 4.2614 7.61716 4.28248C7.56497 4.30356 7.50907 4.31391 7.45279 4.31292C7.39651 4.31193 7.341 4.29961 7.28958 4.2767C7.23817 4.25379 7.19189 4.22076 7.15352 4.17958L4.51562 1.54168V9.47213C4.51562 9.5833 4.47146 9.68992 4.39286 9.76852C4.31425 9.84713 4.20764 9.89129 4.09647 9.89129C3.9853 9.89129 3.87869 9.84713 3.80008 9.76852C3.72147 9.68992 3.67731 9.5833 3.67731 9.47213V1.54168L1.03942 4.17958C1.00104 4.22076 0.954767 4.25379 0.903351 4.2767C0.851934 4.29961 0.79643 4.31193 0.74015 4.31292C0.68387 4.31391 0.627966 4.30356 0.575773 4.28248C0.523581 4.2614 0.476169 4.23002 0.436367 4.19022C0.396564 4.15041 0.365186 4.103 0.344105 4.05081C0.323024 3.99862 0.312671 3.94272 0.313664 3.88643C0.314657 3.83015 0.326975 3.77465 0.349885 3.72323C0.372794 3.67182 0.405825 3.62554 0.447007 3.58717L3.80026 0.233912Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDow);
export default __webpack_public_path__ + "static/media/green-dow.1ca38daca3b642082a7b864ce7862b92.svg";
export { ForwardRef as ReactComponent };